import { GetHotelModel } from "@factory/model/query-model-hotel";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { hotelFormDefault } from "./form.default";
import { HotelFormSchema } from "./form.rule";

export const useFormDefaultHotel = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetHotelModel | undefined) => {
    return !cachedValue
      ? hotelFormDefault
      : ({
          name: cachedValue.location,
          withBreakfast: Boolean(cachedValue.with_breakfast),
          location: cachedValue.location,
          description: cachedValue.description,
        } as HotelFormSchema);
  };

  return {
    getDefault,
  };
};
